var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuroLogoFullOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 366.018,
    height: 161.992,
    viewBox: "0 0 366.018 161.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2021",
    x: 188.011,
    y: 77.266,
    width: 97.007,
    height: 54.818,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2022",
    x: 216.077,
    y: 91.451,
    width: 48.549,
    height: 8.417,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2023",
    x: 269.136,
    y: 77.266,
    width: 96.882,
    height: 54.819,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2024"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2025",
    x: 0,
    y: 0,
    width: 145.187,
    height: 158.363,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2026",
    x: 64.391,
    y: 50.607,
    width: 89.081,
    height: 111.386,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2224",
    x: 117.576,
    y: 77.266,
    width: 89.632,
    height: 54.819,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(-34.004 -382.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(-429.874 243.577)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 463.88, 139.27)",
    filter: "url(#Path_2021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2021-2",
    "data-name": "Path 2021",
    d: "M94.786,40.977a5.66,5.66,0,0,0-1.24,2.461l-5.607,29.5h14.933L105.164,60.3h22.292l14.933,12.638h18.06L146.136,60.3h5.9a15.2,15.2,0,0,0,4.043-.365,10.086,10.086,0,0,0,3.747-1.4,10.949,10.949,0,0,0,2.8-2.1,5.661,5.661,0,0,0,1.24-2.461l1.86-10.542a3.209,3.209,0,0,0-.3-2.461,5.921,5.921,0,0,0-1.86-2.1,8.565,8.565,0,0,0-3.1-1.4,16.436,16.436,0,0,0-4.367-.365h-50.73a15.2,15.2,0,0,0-4.043.365,10.087,10.087,0,0,0-3.747,1.4,10.948,10.948,0,0,0-2.8,2.1",
    transform: "translate(109.68 46.65)",
    fill: "#f8f9fa",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2022-2",
    "data-name": "Path 2022",
    d: "M94.929,47.306h46.011l1.352-7.417H96.105Z",
    transform: "translate(585.611 191.328)",
    fill: "#f8f9fa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 463.88, 139.27)",
    filter: "url(#Path_2022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2022-3",
    "data-name": "Path 2022",
    d: "M94.929,47.306h46.011l1.352-7.417H96.105Z",
    transform: "translate(121.73 52.06)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022-4",
    "data-name": "Path 2022",
    d: "M94.929,47.306h46.011l1.352-7.417H96.105Z",
    transform: "translate(585.611 191.328)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(-457.717 243.576)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 491.72, 139.27)",
    filter: "url(#Path_2023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2023-2",
    "data-name": "Path 2023",
    d: "M127.5,43.62a5.964,5.964,0,0,1,1.242-2.461,10.963,10.963,0,0,1,2.808-2.1,9.609,9.609,0,0,1,3.753-1.4,15.244,15.244,0,0,1,4.05-.365h51.457a16.586,16.586,0,0,1,4.374.365,10.909,10.909,0,0,1,3.429,1.4,5.433,5.433,0,0,1,1.863,2.1,3.2,3.2,0,0,1,.3,2.461L196.4,66.8a5.964,5.964,0,0,1-1.242,2.461,10.963,10.963,0,0,1-2.808,2.1,9.61,9.61,0,0,1-3.753,1.4,15.244,15.244,0,0,1-4.05.365H133.114a16.588,16.588,0,0,1-4.374-.365,10.908,10.908,0,0,1-3.429-1.4c-.108-.091-.216-.152-.324-.243a3.523,3.523,0,0,1-1.566-1.884,3.2,3.2,0,0,1-.324-2.461Z",
    transform: "translate(155.64 46.46)",
    fill: "#f8f9fa",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2024-2",
    "data-name": "Path 2024",
    d: "M168.551,58.695l3.143-18.623h-39.74l-3.143,18.623Z",
    transform: "translate(659.047 191.559)",
    fill: "#f8f9fa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 491.72, 139.27)",
    filter: "url(#Path_2024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2024-3",
    "data-name": "Path 2024",
    d: "M168.551,58.695l3.143-18.623h-39.74l-3.143,18.623Z",
    transform: "translate(167.33 52.29)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024-4",
    "data-name": "Path 2024",
    d: "M168.551,58.695l3.143-18.623h-39.74l-3.143,18.623Z",
    transform: "translate(659.047 191.559)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(-403 233)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 437, 149.84)",
    filter: "url(#Path_2025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2025-2",
    "data-name": "Path 2025",
    d: "M87.136,7.963C89.9,6.369,124.4-1.022,126.239.12S31.97,129.914,28.377,133.254.394,140.7,0,138.948,84.384,9.563,87.136,7.963",
    transform: "translate(9.49 6.48)",
    fill: "#f8f9fa",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 437, 149.84)",
    filter: "url(#Path_2026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2026-2",
    "data-name": "Path 2026",
    d: "M30.43,76.857c-1.07-2.9,15.993-24.878,15.993-24.878s19.905-26.252,22.5-27.663,16,1.172,15.575,3.6S56.838,63.9,61.19,72.417s39.883,43.06,39.351,43.828-28.763-4.152-30.5-5.2S31.5,79.761,30.43,76.857",
    transform: "translate(43.5 33.26)",
    fill: "#f8f9fa",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 34, 382.84)",
    filter: "url(#Path_2224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2224-2",
    "data-name": "Path 2224",
    d: "M74.144,37.483H59.95L54.62,66.957a3.225,3.225,0,0,0,.306,2.458A3.274,3.274,0,0,0,56.413,71.3a1.226,1.226,0,0,1,.281.245,9.4,9.4,0,0,0,3.256,1.4A14.771,14.771,0,0,0,64.1,73.3h44.688a13.674,13.674,0,0,0,3.843-.367,9.291,9.291,0,0,0,3.562-1.4,10.478,10.478,0,0,0,2.665-2.094,5.8,5.8,0,0,0,1.178-2.458l5.021-29.474H110.863l-4.741,27.377H69.4Z",
    transform: "translate(72.56 46.28)",
    fill: "#f8f9fa",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuroLogoFullOutline);
export default __webpack_public_path__ + "static/media/KuroLogoFullOutline.bfade8fe511eedcb3c672af409e8e62a.svg";
export { ForwardRef as ReactComponent };